import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from '@angular/fire/firestore';
import { AuthService } from "../../shared/services/auth.service";

@Injectable({
  providedIn: 'root'
})
export class ChatsService {
  messages: string[] = [];

  constructor(
    private afs: AngularFirestore,
    public authService: AuthService,
    ) {
   }


  //EDIT EVENT
  addMessage(title) {
    this.afs.collection("chats/").add({
      id: this.authService.afAuth.auth.currentUser.uid,
      photoURL: this.authService.afAuth.auth.currentUser.photoURL,
      message: title,
      time: Date.now()
    });
    this.afs.collection('users/'+ this.authService.afAuth.auth.currentUser.uid + '/chats').add({
      id: this.authService.afAuth.auth.currentUser.uid,
      photoURL: this.authService.afAuth.auth.currentUser.photoURL,
      message: title,
      time: Date.now()
    });
    }

}
